import React from 'react';

// Components
import { WpPageLayout, WpPageHeader, WpPageBody } from 'Wpds/components/page-layout';
import LoadingShimmer from 'Shared/components/LoadingShimmer/LoadingShimmer';

// Styles
import './WorkspaceLoading.scss';

const WorkspaceLoading = () => {
  const baseClassName = 'WorkspaceLoading';

  return (
    <WpPageLayout className={baseClassName}>
      <WpPageHeader>
        <LoadingShimmer shape="square" width="175px" height="29px" />
        <div className={`${baseClassName}__tabs`}>
          <LoadingShimmer shape="square" width="85px" height="20px" />
          <LoadingShimmer shape="square" width="85px" height="20px" />
          <LoadingShimmer shape="square" width="85px" height="20px" />
          <LoadingShimmer shape="square" width="85px" height="20px" />
          <LoadingShimmer shape="square" width="85px" height="20px" />
        </div>
      </WpPageHeader>
      <WpPageBody>
        <div className={`${baseClassName}__content`}>
          <LoadingShimmer shape="square" width="125px" height="24px" />
          <LoadingShimmer shape="square" width="215px" height="16px" />
          <LoadingShimmer shape="square" width="300px" height="16px" />
          <LoadingShimmer shape="square" width="125px" height="16px" />
          <LoadingShimmer shape="square" width="200px" height="16px" />
        </div>
      </WpPageBody>
    </WpPageLayout>
  );
};

export default WorkspaceLoading;
